<template>
  <div>
    <div
      v-for="(alert, index) in filteredAlerts"
      :key="index"
      :class="'site-wide-alert '+alert.meta_box.phila_alert_color"
      data-swiftype-index="false"
    >
      <div class="row">
        <div class="medium-centered">
          <div class="grid-x grid-padding-x align-top pvs">
            <div class="cell auto shrink center icon hide-for-small-only align-self-middle">
              <i
                :class="'fa-fw fa-2x '+alert.meta_box.phila_alert_icon"
                aria-hidden="true"
              />
            </div>
            <div class="cell auto message align-self-middle">
              <p v-html="alert.content.rendered" />
              <div />       
              <p v-if="alert.meta_box.phila_alert_active != 1 && alert.meta_box.phila_alert_start > 0 && alert.meta_box.phila_alert_end <= 0">
                In effect: {{ formatDateTime(alert.meta_box.phila_alert_start) }} until further notice
              </p>
              <p v-if="alert.meta_box.phila_alert_end != 1 > 0 && alert.meta_box.phila_alert_end > 0">
                In effect: {{ formatDateTime(alert.meta_box.phila_alert_start) }} to {{ formatDateTime(alert.meta_box.phila_alert_end) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Alerts",
  props: {
    alerts: {
      type: Array,
      required: true,
    },
  },
  data: function() {
    return {
    };
  },
  computed: {
    filteredAlerts() {
      const currentTime = new Date();
      const options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false,
      };
      const formattedCurrentTimeString = currentTime.toLocaleDateString('en-US', options);
      const formattedCurrentTime = new Date(formattedCurrentTimeString);
      return this.alerts.filter(alert => {
        options.timeZone = "UTC";
        const dateObj = new Date(alert.meta_box.phila_alert_end * 1000); 
        const alertEndTimeString = dateObj.toLocaleDateString('en-US', options);
        const alertEndTime = new Date(alertEndTimeString);
        if (alert.meta_box.phila_alert_end > 0 && alertEndTime < formattedCurrentTime && alert.meta_box.phila_alert_active != 1) {
          return false;
        }
        return true;
      });
    },
  },
  methods: {
    formatDateTime(date) {
      if (!date) {
        return ''; 
      }

      const dateObj = new Date(date * 1000); 

      const options = {
        weekday: 'long',
        month: 'long', 
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      };

      options.timeZone = "UTC";

      let formattedDate = dateObj.toLocaleDateString('en-US', options);
      formattedDate = formattedDate.replace(/,? (\d{1,2}):(\d{2}) (AM|PM)/, ' $1:$2 $3');

      return formattedDate
        .replace(/12:00 (AM|PM)/gi, (match) => (match === '12:00 AM' ? '7:00 a.m.' : 'noon'))
        .replace(/(AM|PM)/gi, (match) => (match === 'AM' ? 'a.m.' : 'p.m.'));
    },
  },

};
</script>
